import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-main">
          <h4>Tony's Family Farms Web Shop</h4>
          <p>Browse our current collection of seasonal plants and produce above. We deliver premium quality plants fresh to your door throughout the Metro St. Louis area.</p>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; Tony's Family Farms. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;